// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"0c989746","43":"3727b762","137":"15d3a70f","282":"d2e43cbd","353":"02415a7b","566":"4619e0ff","799":"c9bf888d","892":"820c5f78","950":"37a6255e"}[chunkId] + ".chunk.js";
};